import { render, staticRenderFns } from "./coperistisnakodu.vue?vue&type=template&id=069027f4&"
import script from "./coperistisnakodu.vue?vue&type=script&lang=js&"
export * from "./coperistisnakodu.vue?vue&type=script&lang=js&"
import style0 from "./coperistisnakodu.vue?vue&type=style&index=0&id=069027f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports